<template>
  <div
    class="basic_wrap help-page"
  >
    <div class="red_top_bg help-header">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('shopds.help') }}
      </div>
    </div>
    <div class="wrap_box help-list">
      <router-link
        v-for="(v,k) in data.list"
        :key="k"
        :to="'about/' + v.id"
        class="item"
      >
        {{ v['title_'+lang] }}
      </router-link>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	export default {
		name: "About",
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_icon_type: 'about',
				data: {
					list: []
				},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/about').then((r) => {
					this.data = r.data;
				});
			},
		}
	};
</script>

<style lang="less" scoped>
.basic_wrap {
  box-sizing: border-box;
  min-height: 100vh;
  padding-bottom: 40px;
  background: #f7f5f7 url('../images/ban1/ppbg.png') no-repeat center 50px / 100% auto;
}

.red_top_bg {
  height: 50px;
  background: linear-gradient(110deg, #ff4d72, #e31c5f 60%, #bd1e59);
  box-shadow: 0 8px 22px rgba(189, 30, 89, .14);

  .big_tit {
    top: 0;
    width: calc(100% - 108px);
    height: 50px;
    overflow: hidden;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    line-height: 50px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.back_left {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 44px;
  height: 50px;
  margin: 0;
  background-size: 14px auto;
  cursor: pointer;
}

.wrap_box {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: calc(100% - 32px);
  margin: 18px 16px 0;
  padding: 2px 16px;
  border: 1px solid #f1e8ed;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(50, 28, 42, .07);
}

.item {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 12px 22px 12px 0;
  border-bottom: 1px solid #f1edf0;
  color: #29252b;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  text-decoration: none;
  word-break: break-word;
}

.item:last-child {
  border-bottom: 0;
}

.item::after {
  position: absolute;
  top: 50%;
  right: 3px;
  width: 7px;
  height: 7px;
  border-top: 1px solid #b9aeb5;
  border-right: 1px solid #b9aeb5;
  content: '';
  transform: translateY(-50%) rotate(45deg);
}

/* Help centre follows the shared pay-page visual and 12 / 14 / 16px type scale. */
.help-page {
  min-height: 100vh;
  padding-bottom: 1.7rem;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 14px;
}

.help-page .help-header {
  position: relative;
  height: 56px;
  border-bottom: 1px solid rgba(235, 235, 235, .9);
  background: rgba(255, 255, 255, .9);
  box-shadow: 0 4px 14px rgba(28, 42, 61, .06);
}

.help-page .help-header .big_tit {
  top: 0;
  width: 100%;
  height: 56px;
  padding: 0 56px;
  box-sizing: border-box;
  color: #1d3048;
  font-size: 16px;
  font-weight: 700;
  line-height: 56px;
  text-align: center;
}

.help-page .help-header .back_left {
  z-index: 2;
  top: 0;
  left: 8px;
  width: 48px;
  height: 56px;
  background: none;
}

.help-page .help-header .back_left::after {
  position: absolute;
  top: 21px;
  left: 17px;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid #314258;
  border-left: 2px solid #314258;
  content: '';
  transform: rotate(45deg);
}

.help-page .help-list {
  width: auto;
  margin: 18px 16px 0;
  padding: 2px 18px;
  border: 1px solid rgba(255, 255, 255, .9);
  border-radius: 16px;
  background: rgba(255, 255, 255, .96);
  box-shadow: 0 12px 28px rgba(28, 42, 61, .1);
}

.help-page .help-list .item {
  min-height: 60px;
  padding: 14px 28px 14px 0;
  border-bottom: 1px solid #edf0f4;
  color: #26384e;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.help-page .help-list .item:active {
  color: #df2352;
}

.help-page .help-list .item::after {
  right: 4px;
  width: 8px;
  height: 8px;
  border-width: 1px 1px 0 0;
  border-color: #8a97a8;
}
</style>
